import { ConfigProvider } from 'antd';
import { DataProvider } from './contexts/DataContext';
import { SelectionProvider } from './contexts/SelectionContext';
import { MapProvider } from './contexts/MapContext';
import { SankeyProvider } from './contexts/SankeyContext';
import { DisplayModeProvider } from './contexts/DisplayModeContext';
import { theme } from './config/theme';
import MapPage from './pages/MapPage';
import { SankeyView } from './components/Sankey';

// Import styles
import './styles/variables.css';
import './styles/leaflet-dark.css';
import './App.css';

function App() {
  return (
    <ConfigProvider theme={theme}>
      <DataProvider>
        <SelectionProvider>
          <DisplayModeProvider>
            <MapProvider>
              <SankeyProvider>
                <div className="App">
                  <MapPage />
                  <SankeyView />
                </div>
              </SankeyProvider>
            </MapProvider>
          </DisplayModeProvider>
        </SelectionProvider>
      </DataProvider>
    </ConfigProvider>
  );
}

export default App;
